import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { FileType, GlobalConstantsColor, GlobalConstantsRegex, GlobalConstantsSonstige, GlobalConstantsTexte, GlobalFunctions, InputErrorStateMatcher, ValueFormat } from 'globales-projekt-angular';
import { ModalAuswahlQuelleComponent } from 'src/app/components/pages/anwendung/modal/modal-auswahl-quelle/modal-auswahl-quelle.component';
import { UserBetrieb } from 'src/app/data/user/user-betrieb.model';
import { UserQuelleFlaeche } from 'src/app/data/user/user-quelle-flaeche.model';
import { UserQuelleSonstige } from 'src/app/data/user/user-quelle-sonstige.model';
import { UserQuelleStall } from 'src/app/data/user/user-quelle-stall.model';
import { AuswahlAnzeigeFlaechenquelle } from 'src/app/data/ws/auswahl-anzeige-flaechenquelle.model';
import { AuswahlAnzeigeSonstigeQuelle } from 'src/app/data/ws/auswahl-anzeige-sonstige-quelle.model';
import { AuswahlAnzeigeStallquelle } from 'src/app/data/ws/auswahl-anzeige-stallquelle.model';
import { ErgebnisQuelleGes } from 'src/app/data/ws/ergebnis-quelle-ges.model';
import { WindRichtlinienab } from 'src/app/data/ws/wind-richtlinienab.model';
import { ConstantsSonstige } from 'src/app/immutable/constants-sonstige';
import { ConstantsTableColsFlaeche } from 'src/app/immutable/constants-table-cols-quelle-flaeche';
import { ConstantsTableColsSonstige } from 'src/app/immutable/constants-table-cols-quelle-sonstige';
import { ConstantsTableColsStall } from 'src/app/immutable/constants-table-cols-quelle-stall';
import { QuelleTyp } from 'src/app/immutable/enums/quelle-typ';
import { ApiService } from 'src/app/services/api.service';
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'app-betrieb',
  templateUrl: './betrieb.component.html',
  styleUrls: ['./betrieb.component.css']
})
export class BetriebComponent implements OnInit {
  tooltipPosition = new FormControl(GlobalConstantsSonstige.POSITION_OPTIONS[0]);
  valueFormat: ValueFormat = new ValueFormat();
  filesToUpload: FileList = null;

  ausgeklapptStallquellen: boolean = false;
  ausgeklapptFlaechenquellen: boolean = false;
  ausgeklapptSonstigeQuellen: boolean = false;

  displayedColsStallquelle: string[] = ConstantsTableColsStall.getColumns();
  displayedColsFlaechenquelle: string[] = ConstantsTableColsFlaeche.getColumns();
  displayedColsSonstigeQuelle: string[] = ConstantsTableColsSonstige.getColumns();

  readonly GlobalConstantsColor = GlobalConstantsColor;
  readonly maxGesamtemissionGeS = ConstantsSonstige.MAX_GESAMTEMISSION_GE_S;

  ergebnisQuelleGes: ErgebnisQuelleGes = new ErgebnisQuelleGes();

  dataAuswahlAnzeigeStallquelle: MatTableDataSource<AuswahlAnzeigeStallquelle> = new MatTableDataSource();
  dataAuswahlAnzeigeFlaechenquelle: MatTableDataSource<AuswahlAnzeigeFlaechenquelle> = new MatTableDataSource();
  dataAuswahlAnzeigeSonstigeQuelle: MatTableDataSource<AuswahlAnzeigeSonstigeQuelle> = new MatTableDataSource();

  zusatzabstandFormControl: FormControl = new FormControl(null, [
    Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_ODER_KOMMA_1),
  ]);
  gewichtungsfaktorFormControl: FormControl = new FormControl(null, [
    Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_ODER_KOMMA_2),
  ]);

  dataWindRichtlinienabList: MatTableDataSource<WindRichtlinienab> = new MatTableDataSource();

  windhaeufigkeitFormControlList: FormControl[] = [];
  hgFormControlList: FormControl[] = [];
  gebietskategorieFormControlList: FormControl[] = [];

  formControlGanzZahlLaeng4OderKomma2NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_ODER_KOMMA_2_TEXT);
  formControlGanzZahlLaeng4OderKomma1NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_ODER_KOMMA_1_TEXT);

  matcher: InputErrorStateMatcher = new InputErrorStateMatcher();
 
  constructor(
    private apiService: ApiService,
    private dialog: MatDialog,
    private localService: LocalService,
  ) {
    this.localService.betriebComponentRef.next(this);
  }

  ngOnInit(): void {
 
    this.zusatzabstandFormControl.valueChanges.subscribe((value) => {
      this.localService.updateZusatzabstand(this.valueFormat.parseNumber(value));
      this.localService.mainComponentRef.value.checkAndSetButtonState();
    });

    this.gewichtungsfaktorFormControl.valueChanges.subscribe((value) => {
      this.localService.updateGewichtungsfaktor(this.valueFormat.parseNumber(value));
      this.localService.mainComponentRef.value.checkAndSetButtonState();
    });

 
    this.getAndSetErgebnisseForUserData(false, false);


  }


  onClickQuelleHinzufuegen() {
    const dialogRef = this.dialog.open(ModalAuswahlQuelleComponent, {
      autoFocus: false,
      width: GlobalConstantsSonstige.BREITE_MODAL_GROSS,
      maxWidth: GlobalConstantsSonstige.BREITE_MODAL_GROSS,
      disableClose: true,
      data: false,
    });

    let dialog: ModalAuswahlQuelleComponent = dialogRef.componentInstance;
    dialogRef.afterClosed().subscribe((result) => {
      if (result > 0) {
        if (dialog.getQuelle() == QuelleTyp.STALL) {
          this.ausgeklapptStallquellen = true;
          this.localService.aktuellerUserBetrieb.value.userQuelleStallList.push(dialog.getUserStallquelle());
        } else if (dialog.getQuelle() == QuelleTyp.FLAECHE) {
          this.ausgeklapptFlaechenquellen = true;
          this.localService.aktuellerUserBetrieb.value.userQuelleFlaecheList.push(dialog.getUserFlaechenquelle());
        } else if (dialog.getQuelle() == QuelleTyp.SONSTIGE) {
          this.ausgeklapptSonstigeQuellen = true;
          this.localService.aktuellerUserBetrieb.value.userQuelleSonstigeList.push(dialog.getUserSonstigeQuelle());
        }

        this.getAndSetErgebnisseForUserData(true, false);
      }

      this.localService.mainComponentRef.value.checkAndSetButtonState();
    });
  }


  onClickEditieren(quelleTyp: QuelleTyp, index: number) {
    const dialogRef = this.dialog.open(ModalAuswahlQuelleComponent, {
      autoFocus: false,
      width: GlobalConstantsSonstige.BREITE_MODAL_GROSS,
      maxWidth: GlobalConstantsSonstige.BREITE_MODAL_GROSS,
      disableClose: true,
      data: true
    });

    let userBetrieb: UserBetrieb = this.localService.aktuellerUserBetrieb.value;
    let dialog: ModalAuswahlQuelleComponent = dialogRef.componentInstance;

    if (quelleTyp == QuelleTyp.STALL) {
      let userQuelleStallList: UserQuelleStall[] = userBetrieb.userQuelleStallList;
      dialog.setUserStallquelle(userQuelleStallList[index]);
    } else if (quelleTyp == QuelleTyp.FLAECHE) {
      let userQuelleFlaecheList: UserQuelleFlaeche[] = userBetrieb.userQuelleFlaecheList;
      dialog.setUserFlaechenquelle(userQuelleFlaecheList[index]);
    } else if (quelleTyp == QuelleTyp.SONSTIGE) {
      let userQuelleSonstigeList: UserQuelleSonstige[] = userBetrieb.userQuelleSonstigeList;
      dialog.setUserSonstigeQuelle(userQuelleSonstigeList[index]);
    }

    dialogRef.afterClosed().subscribe((result) => {
      if (result > 0) {
        if (quelleTyp == QuelleTyp.STALL) {
          userBetrieb.userQuelleStallList[index] = dialogRef.componentInstance.getUserStallquelle();
        } else if (quelleTyp == QuelleTyp.FLAECHE) {
          userBetrieb.userQuelleFlaecheList[index] = dialogRef.componentInstance.getUserFlaechenquelle();
        } else if (quelleTyp == QuelleTyp.SONSTIGE) {
          userBetrieb.userQuelleSonstigeList[index] = dialogRef.componentInstance.getUserSonstigeQuelle();
        }

        this.getAndSetErgebnisseForUserData(true, false);
      }
    });
  }

  onClickEntfernen(quelleTyp: QuelleTyp, index: number) {
    let userBetrieb: UserBetrieb = this.localService.aktuellerUserBetrieb.value;

 
    if (quelleTyp == QuelleTyp.STALL) {
 
      this.localService.aktuellerUserBetrieb.value.userQuelleStallList.splice(index, 1);
    } else if (quelleTyp == QuelleTyp.FLAECHE) {
      let userQuelleFlaecheList: UserQuelleFlaeche[] = userBetrieb.userQuelleFlaecheList;

      userQuelleFlaecheList.splice(index, 1);
    } else if (quelleTyp == QuelleTyp.SONSTIGE) {
      let userQuelleSonstigeList: UserQuelleSonstige[] = userBetrieb.userQuelleSonstigeList;

      userQuelleSonstigeList.splice(index, 1);
    }

 
    this.getAndSetErgebnisseForUserData(true, false);
  }


  public getAndSetErgebnisseForUserData(replaceValue: boolean, showImportMeldung: boolean) {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);

    if (replaceValue) {
      this.localService.updateZusatzabstand(0);
    }


    let userBetrieb: UserBetrieb = JSON.parse(
      JSON.stringify(this.localService.aktuellerUserBetrieb.value)
    );

    userBetrieb.userQuelleSonstigeList =
      userBetrieb.userQuelleSonstigeList.filter(
        (userQuelleFlaeche) =>
          userQuelleFlaeche.idUserQuelleSonstige > -1 ||
          userQuelleFlaeche.idUserQuelleSonstige == null
      );
    userBetrieb.userQuelleFlaecheList =
      userBetrieb.userQuelleFlaecheList.filter(
        (userQuelleFlaeche) =>
          userQuelleFlaeche.idUserQuelleFlaeche > -1 ||
          userQuelleFlaeche.idUserQuelleFlaeche == null
      );
    userBetrieb.userQuelleStallList = userBetrieb.userQuelleStallList.filter(
      (userQuelleFlaeche) =>
        userQuelleFlaeche.idUserQuelleStall > -1 ||
        userQuelleFlaeche.idUserQuelleStall == null
    );



    this.apiService.postErgebnisBetrieb(userBetrieb).subscribe((response) => {
 

      this.ergebnisQuelleGes = response.ergebnisQuelleGes;

      let auswahlAnzeigeStallquelle: AuswahlAnzeigeStallquelle[] = [];
      for (let entry of response.ergebnisQuelleStallList) {
        auswahlAnzeigeStallquelle.push(new AuswahlAnzeigeStallquelle(entry, this.localService));
      }
      this.dataAuswahlAnzeigeStallquelle = new MatTableDataSource(auswahlAnzeigeStallquelle);

      let auswahlAnzeigeFlaechenquelle: AuswahlAnzeigeFlaechenquelle[] = [];
      for (let entry of response.ergebnisQuelleFlaecheList) {
        auswahlAnzeigeFlaechenquelle.push(new AuswahlAnzeigeFlaechenquelle(entry, this.localService));
      }
      this.dataAuswahlAnzeigeFlaechenquelle = new MatTableDataSource(auswahlAnzeigeFlaechenquelle);

      let auswahlAnzeigeSonstigeQuelle: AuswahlAnzeigeSonstigeQuelle[] = [];
      for (let entry of response.ergebnisQuelleSonstigeList) {
        auswahlAnzeigeSonstigeQuelle.push(new AuswahlAnzeigeSonstigeQuelle(entry));
      }
      this.dataAuswahlAnzeigeSonstigeQuelle = new MatTableDataSource(auswahlAnzeigeSonstigeQuelle);

      if (replaceValue) {
        this.zusatzabstandFormControl.setValue(this.valueFormat.getStringDecimal(response.ergebnisQuelleGes.zusatzabstand, 1));
        this.gewichtungsfaktorFormControl.setValue(this.valueFormat.getStringDecimal(response.ergebnisQuelleGes.maximalerGewichtungsfaktor, 2));

      }

      else {
        this.zusatzabstandFormControl.setValue(this.valueFormat.getStringDecimal(this.localService.aktuellerUserBetrieb.value.zusatzabstand, 1));
        this.gewichtungsfaktorFormControl.setValue(this.valueFormat.getStringDecimal(this.localService.aktuellerUserBetrieb.value.gewichtungsfaktor, 2));

      }

      if (showImportMeldung) {

        alert(GlobalConstantsTexte.EINLESEN_DURCHGEFUEHRT);
      }

      this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
    });
  }

  entfernenInputs() {
    this.zusatzabstandFormControl.setValue(this.valueFormat.getStringDecimal(0, 1));
    this.gewichtungsfaktorFormControl.setValue(this.valueFormat.getStringDecimal(0, 2));

    this.dataAuswahlAnzeigeStallquelle = new MatTableDataSource<AuswahlAnzeigeStallquelle>([]);
    this.dataAuswahlAnzeigeFlaechenquelle = new MatTableDataSource<AuswahlAnzeigeFlaechenquelle>([]);
    this.dataAuswahlAnzeigeSonstigeQuelle = new MatTableDataSource<AuswahlAnzeigeSonstigeQuelle>([]);

    this.localService.aktuellerUserBetrieb.value.userQuelleStallList = [];
    this.localService.aktuellerUserBetrieb.value.userQuelleFlaecheList = [];
    this.localService.aktuellerUserBetrieb.value.userQuelleSonstigeList = [];

    this.ergebnisQuelleGes.gesamtemissionen = 0;
    this.ergebnisQuelleGes.emissionsschwerpunktX = null;
    this.ergebnisQuelleGes.emissionsschwerpunktY = null;
  }

  getIsValid(): boolean {
    let isValid: boolean = true;
    isValid = isValid && this.zusatzabstandFormControl.valid;
    isValid = isValid && this.gewichtungsfaktorFormControl.valid;
    /*
    isValid = isValid && (
      this.localService.aktuellerUserBetrieb.value.userBetrieb.userQuelleStallList.length > 0 ||
      this.localService.aktuellerUserBetrieb.value.userBetrieb.userQuelleFlaecheList.length > 0 ||
      this.localService.aktuellerUserBetrieb.value.userBetrieb.userQuelleSonstigeList.length > 0
    );
*/
    return isValid;
  }

  onClickExportBetrieb() {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);


    GlobalFunctions.downloadFile(
      FileType.JSON,
      JSON.stringify(this.localService.aktuellerUserBetrieb.value, null, 2),
      GlobalFunctions.getFileExportName(this.localService.aktuellerUserBetrieb.value.bezeichnung),
      FileType.JSON_SHORT
    );

    this.localService.mainComponentRef.value?.waitingForDataSpinner(false);

  }

  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const files = input.files;

    if (!files || files.length === 0) {
      return;
    }

    const file = files[0];

    let erlaubteExtensions: FileType[] = [];
    erlaubteExtensions.push(FileType.JSON_EXT);

    let erlaubteExtensionsText: FileType[] = [];
    erlaubteExtensionsText.push(FileType.JSON_SHORT);

    let msg: string = GlobalFunctions.getFilesValidFileTypeMsgString(
      files,
      erlaubteExtensions,
      erlaubteExtensionsText,
      GlobalConstantsTexte.KEINE_GUELTIGER_DATEITYP_FUER_DATEI
    );

    if (msg.length !== 0) {
      alert(msg);
      return;
    }

    try {
      const text = await file.text();
      const parsedData: unknown = JSON.parse(text);

      if (!UserBetrieb.isValidBetriebImport(parsedData)) {
        alert(GlobalConstantsTexte.ERROR_DATEI_GÜLTIG_NICHT_FORMAT);
        return;
      }

      this.localService.aktuellerUserBetrieb.next(parsedData as UserBetrieb);
      console.log(parsedData);

      this.localService.mainComponentRef.value.bezeichnungFormControl.setValue(this.localService.aktuellerUserBetrieb.value.bezeichnung);
      this.localService.mainComponentRef.value.beschreibungFormControl.setValue(this.localService.aktuellerUserBetrieb.value.beschreibung);
      this.localService.winddatenGebietskategorieComponentRef.value.importWinddaten(this.localService.aktuellerUserBetrieb.value.userWindRichtlinienabList);

      this.getAndSetErgebnisseForUserData(false, true);

    } catch (error) {
      console.error(error);
      alert(GlobalConstantsTexte.ERROR_DATEI_NICHT_VERARBEITET);
    } finally {
      input.value = '';
    }
  }


}
 